import { ReelSymbolStates } from "./ReelSpriteSymbolArea";
import { StateHandler } from "../../utils/StateHandler";
import { BasicSymbolType, ISymbolConfig } from "./config/IReelSymbolStruct";
import { SymbolData } from "./config/SymbolData";
import {  gsap } from "gsap";
import { SimpleSpriteSwap } from "../../../game/modules/symbol/SimpleSpriteSwap";

export interface ISymbolAnimationConf {
    // Function Path.
    state: any;

    // Core values.
    sym?: string;
    sizeType?: any;
    // Basic animSettings.
    ease?: any;
    alpha?: number;
    duration?: number;
    repeat?: number;

    // Extra options
    forceState?: boolean;
}

export abstract class ReelBaseSymbol extends PIXI.Container {

    protected _mainSprite: SimpleSpriteSwap;
    protected _darkSquareGfx: PIXI.Graphics;

    protected _timeLine: gsap.core.Timeline | undefined;
    protected _subTimeline: gsap.core.Timeline | undefined;

    private _posID: number[];
    private _symConfig: ISymbolConfig;

    private _symbolState: ReelSymbolStates = new StateHandler();
    private _symbolSizeType: StateHandler = new ReelSymbolStates();

    constructor(ID: number, state: any, type: any) {
        super();

        this._posID = [ID];
        this.sizeType.set(type);
        this.state.set(state);
    }

    public abstract get symbolSizeY(): number;
    public abstract get symbolSizeX(): number;

    public abstract get symbolHeight(): number;
    public abstract get symbolWidth(): number;

    public abstract changeState(newStateConfig: ISymbolAnimationConf): gsap.core.Timeline | undefined;
    public abstract remove(): void;

    public get state(): ReelSymbolStates { return this._symbolState };
    public get sizeType(): ReelSymbolStates { return this._symbolSizeType };

    public get symbolConfig(): ISymbolConfig { return this._symConfig };
    public set symbolConfig(conf: ISymbolConfig) { this._symConfig = conf; };

    public get posID(): number[] { return this._posID };
    public setPosID(value: number, reverse?: boolean) {
        const size: number = this.stackedValue;
        for (let s: number = 0; s < size; s++) this._posID[s] = value + (reverse ? -s : s);
        this._posID.sort((a: number, b: number) => a - b);
    }

    public get symName(): string { return this.symbolConfig.NAME; }

    public get isWild(): boolean { return this.symbolConfig.NAME == BasicSymbolType.WILD; };
    public get isMystery(): boolean { return this.symbolConfig.NAME == "M"; };
    public get isScatter(): boolean { return this.symbolConfig.NAME == BasicSymbolType.SCATTER; };

    public get isLowValue(): boolean { return SymbolData.isLowSymbol(this.symName); }
        
    public get isHighValSym(): boolean { return  SymbolData.isHighSymbol(this.symName); }

    public get stackedValue(): number {
        return SymbolData.getStackedValue(this.symbolConfig, this.state.value, this.sizeType.value);
    }

    public get isStacked(): boolean { return this.stackedValue > 1; }

    public get isNormalSym(): boolean { return this.isLowValue || this.isHighValSym }

    public get isInactive(): boolean { return this.state.equal(ReelSymbolStates.INACTIVE) };
} 